import { useCallback } from "react";
import { ServiceEnvironment } from "Enums/ServiceEnvironment";
import { CentralAdminEntityType } from "Enums/CentralAdminEntityType";
import { ScopeItem } from "Shared/Components/Scope/Scopes.types";
import { centralAdminItemSchema } from "../CentralAdminTopology";
import { useORPCClient } from "Core/oRPC/useOPRC";

export const useSubstrateFEMachine = () => {
    const orpcClient = useORPCClient();

    const getFEMachineList = useCallback(
        async (env?: ServiceEnvironment, workload?: string, selectedScopesSoFar?: ScopeItem[]): Promise<ScopeItem[]> => {
            const selectedCapacityUnit = selectedScopesSoFar?.find((scope) => scope.ScopeType?.toLowerCase() === "capacityunit");

            if (!selectedCapacityUnit) {
                return [];
            }

            const feMachineRequest = {
                Environment: env,
                Workload: workload || "",
                TargetType: CentralAdminEntityType.Machine,
                FilterType: CentralAdminEntityType.CapacityUnit,
                FilterValue: selectedCapacityUnit.Value?.toUpperCase()
            };

            const feMachineOutput = await orpcClient.inventoryApi.postTopology(feMachineRequest);
            const feMachineParsedOutput = centralAdminItemSchema.array().parse(feMachineOutput);
            return feMachineParsedOutput.map((item) => ({
                ScopeType: "Machine",
                Value: item.Name
            }));
        },
        [orpcClient]
    );

    return {
        getFEMachineList
    };
};
